import { xhrApiClient } from '@/config/xhrApiClient'
import { API_DEACTIVATE_CARD_LINK } from '@/config/xhrApiClientRouteNames'

interface IPostDeactivateCardLinkQuery {
    card_uuid: string
}

const postDeactivateCardLink = async (
    payload: IPostDeactivateCardLinkQuery
) => {
    const { data } = await xhrApiClient.post(API_DEACTIVATE_CARD_LINK, payload)

    return data
}

export default postDeactivateCardLink
